import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = ({ className }) => {
  return <CircularProgress className="p-2" color="inherit" />;
};

export default Loader;
